import {createContext, useContext} from 'react'

/** Row height inherited by menu/sidebar rows — `md` 36px, `lg` 48px. */
export type MenuSize = 'md' | 'lg'

/**
 * Row height inherited by menu/sidebar rows. `md` (36px) is the MUI-aligned
 * default; `lg` (48px) is the roomier nav rail in Figma's Admin-Panel v3, where
 * **top-level** rows are 48px and rows **nested inside** a `CollapsibleMenuItem`
 * are 36px. `Sidebar size="lg"` sets the top level, and `CollapsibleMenuItem`
 * resets its child panel back to `md`, which produces that 48/36 pairing without
 * anyone setting a height per row.
 *
 * `dense` still wins over this (a dense rail is 32px throughout), as does an
 * explicit `smallScreen` on an individual row.
 */
export const MenuSizeContext = createContext<MenuSize>('md')

/** Provide a row height to all descendant menu items. */
export const MenuSizeProvider = MenuSizeContext.Provider

/** Read the inherited row height (default `md`). */
export function useMenuSize(): MenuSize {
  return useContext(MenuSizeContext)
}
